import * as React from 'react';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { FullScreenIcon } from '../../../custom_shared/icons';
import { ClickableIcon } from '../../../common/components';
import { getIconSize } from '../../../documents/config/iconSizes';
import { DocumentPreviewStore } from '../../stores';
import './FullScreenButton.less';

interface Props {
    documentPreviewStore: DocumentPreviewStore;
    lightMode?: boolean;
}

const FullScreenButton: React.FC<Props> = ({ documentPreviewStore, lightMode }) => {
    const iconSize = getIconSize('previewControls', lightMode);

    return (
        <Tooltip title="Open in full screen" placement="topLeft">
            <ClickableIcon
                width={iconSize}
                height={iconSize}
                icon={FullScreenIcon}
                onClick={() => documentPreviewStore.setPreviewPosition('fullScreen')}
            />
        </Tooltip>
    );
};

export default observer(FullScreenButton);
